import { observer } from "mobx-react-lite";
import { dashboardDataTableStore } from "../../stores/data-table.store";
import EsgDataTableTab from "./EsgDataTableTab";
import EDataChartsTab from "./EDataChartsTab";

const DataTableSection = observer(() => {
  const { dataTableSection } = dashboardDataTableStore;
  if (!dataTableSection) return null;
  return (
    <div className="border-b border-border/70 space-y-3 px-3 pb-3">
      {dataTableSection === "esg" && <EsgDataTableTab />}
      {dataTableSection === "charts" && <EDataChartsTab />}
    </div>
  );
});

export default DataTableSection;
